import React, {useEffect, useState} from 'react';
import {Modal} from '../../../../../../shared/components/modal/modal';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {DesktopProps} from '../model';
import {EsiaRegCardFormScreen} from '../index';
import {EsiaRegCardMap} from '../../map';
import {Platform, View} from 'react-native';
import {CustomScrollView} from '../../../../../../shared/components/scrollView';
import EsiaActivateCard from '../../../../esiaActivateCard/esiaActivateCard';
import {esiaRegistrationInfoSelector, esiaUserHasNoCardsSelector} from '../../../../../../redux/selectors/login';
import {useSelector} from 'react-redux';
import {UserCardList} from '../components/userCardList/view';
import {useRegCardState} from '../../../esiaRegCardState/useRegCardState';
import {EsiaRegStep} from '../../../../../profile/desktop/components/applications/view';

export const EsiaRegCardFlowHandler = ({onClose}: DesktopProps) => {
  const userHasNoCards = useSelector(esiaUserHasNoCardsSelector);
  const esiaRegInfo = useSelector(esiaRegistrationInfoSelector);

  const [esiaRegStep, setEsiaRegStep] = useState(EsiaRegStep.UsersList);

  const {addData} = useRegCardState();

  useEffect(() => {
    if (esiaRegInfo) {
      addData(esiaRegInfo);
    }
  }, []);

  const styles = useStyles(({theme}) => ({
    modalTitle: {
      paddingTop: 20,
      ...theme.fonts.h3,
    },
    modalWrap: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingHorizontal: 0,
      overflow: 'hidden',
      width: 878,
      margin: Platform.OS === 'ios' ? 1 : 0,
    },
    contentStyle: {
      paddingTop: 0,
    },
    backButton: {
      marginTop: 16,
    },
  }));

  let title = userHasNoCards ? 'Ваше заявление принято' : 'Оформление нефинансовой ЕСК';
  const RegStepComponent = () => {
    switch (esiaRegStep) {
      case EsiaRegStep.UsersList:
        title = 'Оформление нефинансовой ЕСК';
        return <UserCardList onClose={() => {}} onEsiaSubmit={() => setEsiaRegStep(EsiaRegStep.Form)} />;
      case EsiaRegStep.Form:
        title = 'Оформление нефинансовой ЕСК';
        return (
          <EsiaRegCardFormScreen
            onEsiaSubmit={() => {
              setEsiaRegStep(EsiaRegStep.DeliveryType);
            }}
          />
        );
      case EsiaRegStep.DeliveryType:
        title = 'Выбрать способ получения';
        return <EsiaRegCardMap onGoBack={() => setEsiaRegStep(EsiaRegStep.Form)} />;
      default:
        return null;
    }
  };

  return (
    <Modal
      title={title}
      onClose={onClose}
      titleStyle={styles.modalTitle}
      wrapStyle={styles.modalWrap}
      contentStyle={styles.contentStyle}>
      {userHasNoCards ? (
        <EsiaActivateCard onCloseModal={onClose} />
      ) : (
        <View style={{maxHeight: '70%'}}>
          <CustomScrollView
            withRefresh={false}
            contentInsetAdjustmentBehavior='automatic'
            children={RegStepComponent()}
          />
        </View>
      )}
    </Modal>
  );
};
